export const cardLimits = {
    organization: {
        characters: 30
    },
    attn: {
        characters: 30
    },
    city: {
        characters: 30
    },
    street1: {
        characters: 35
    },
    street2: {
        characters: 25
    },
    street3: {
        characters: 25
    }
};

